(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["flowdays-newsletter"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.flowdays').forEach((section) => {
    const consent = section.querySelector('.flowdays__consent input[type="checkbox"]');
    const error = section.querySelector('.flowdays__consent-error');
    if (!consent || !error || consent.dataset.validationReady === 'true') return;
    consent.dataset.validationReady = 'true';
    consent.addEventListener('invalid', (event) => {
      event.preventDefault();
      consent.setAttribute('aria-invalid', 'true');
      error.hidden = false;
    });
    consent.addEventListener('change', () => {
      if (!consent.checked) return;
      consent.setAttribute('aria-invalid', 'false');
      error.hidden = true;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  const formatFlowflowProductPrice = (value) => value.trim().replace(/([.,]00)(?=\s*$)/, '');

  const syncProductButtonPrice = (button) => {
    const section = button.closest('[id^="shopify-section-"]');
    const price = section?.querySelector('.main-product__price .price--on-sale .price-item--sale')
      || section?.querySelector('.main-product__price .price__regular .price-item--regular');
    const text = button.querySelector('.button__text');
    const label = button.dataset.addToCartLabel;
    const formattedPrice = price ? formatFlowflowProductPrice(price.textContent) : '';
    if (formattedPrice) section?.querySelectorAll('[data-product-title-price]').forEach((item) => { item.textContent = formattedPrice; });
    if (button.disabled) return;
    if (formattedPrice && text && label) text.textContent = `${label} | ${formattedPrice}`;
  };

  const initializeProductButtonPrices = (root = document) => {
    root.querySelectorAll('.main-product__add-to-cart [data-show-price="true"]').forEach((button) => {
      syncProductButtonPrice(button);
      if (button.dataset.priceSyncBound === 'true') return;
      const section = button.closest('[id^="shopify-section-"]');
      const price = section?.querySelector('.main-product__price');
      if (price) new MutationObserver(() => syncProductButtonPrice(button)).observe(price, { childList: true, subtree: true, characterData: true });
      button.dataset.priceSyncBound = 'true';
    });
  };

  document.addEventListener('DOMContentLoaded', () => initializeProductButtonPrices());
  document.addEventListener('change', (event) => {
    if (!event.target.closest('variant-selects')) return;
    window.setTimeout(() => initializeProductButtonPrices(event.target.closest('[id^="shopify-section-"]')), 0);
  });
  if (Shopify.designMode) document.addEventListener('shopify:section:load', (event) => initializeProductButtonPrices(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-quiz"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('product-quiz')) return;
  // Product slots stay merchant-configurable: a = Mousse, b = Plume, c = Pépite.
  // Point triples are ordered [Pépite, Mousse, Plume]. Labels never affect scoring.
  const POINTS = [
    [[2,0,0],[0,2,0],[0,1,1],[0,0,2],[0,0,2]],
    [[1,1,0],[0,1,1],[1,1,0],[2,0,0],[0,1,2]],
    [[5,0,0],[0,5,0],[0,0,5],[0,5,0],[5,0,0]]
  ];
  function publishQuizEvent(name, data = {}) {
    if (window.Shopify?.analytics?.publish) {
      window.Shopify.analytics.publish('flowflow:' + name, data);
    }
  }
  const SLOTS = ['c', 'a', 'b'];
  const FALLBACK = ['a', 'b', 'c'];
  function scoreAnswers(answers) {
    const questions = POINTS.map((options, q) => {
      const scores = {a:0, b:0, c:0};
      for (const answer of answers[q]) {
        const points = options[answer - 1];
        if (points) SLOTS.forEach((key, i) => { scores[key] += points[i]; });
      }
      return scores;
    });
    const totals = {a:0,b:0,c:0};
    questions.forEach(scores => SLOTS.forEach(key => { totals[key] += scores[key]; }));
    return {questions, totals};
  }
  function rankProducts({questions, totals}, available) {
    return [...available].sort((x,y) => totals[y]-totals[x]
      || questions[2][y]-questions[2][x]
      || questions[0][y]-questions[0][x]
      || FALLBACK.indexOf(x)-FALLBACK.indexOf(y));
  }
  class ProductQuiz extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.answers = [[], [], []];
      const startOnQuestion = new URLSearchParams(location.search).get('quiz_start') === '1';
      this.screen = startOnQuestion ? 'q1' : (this.dataset.intro === 'true' ? 'intro' : 'q1');
      this.availableKeys = Array.from(this.querySelectorAll('[data-result]'), node => node.dataset.result);
      this.addEventListener('click', event => {
        const button = event.target.closest('button');
        if (!button || !this.contains(button)) return;
        if (button.hasAttribute('data-start')) { publishQuizEvent('quiz_start', {source: new URLSearchParams(location.search).get('quiz_source') === 'product' ? 'product' : 'homepage', originProduct: new URLSearchParams(location.search).get('product') || null}); this.show('q1'); }
        else if (button.hasAttribute('data-answer')) this.choose(button);
        else if (button.hasAttribute('data-continue')) this.continue();
        else if (button.hasAttribute('data-back')) this.back();
        else if (button.hasAttribute('data-retake')) this.reset();
      }, { signal: this.controller.signal });
      this.querySelectorAll('.main-product__error').forEach(node => {
        node.setAttribute('role', 'alert');
        node.setAttribute('aria-live', 'polite');
      });
      this.videoVisible = !('IntersectionObserver' in window);
      if ('IntersectionObserver' in window) {
        this.videoObserver = new IntersectionObserver(entries => {
          this.videoVisible = entries.some(entry => entry.isIntersecting);
          this.syncVideo();
        });
        this.querySelectorAll('.pq__video').forEach(video => this.videoObserver.observe(video));
      }
      this.show(this.screen, false);
      this.addEventListener('click', event => {
        const link = event.target.closest('[data-result]:not([hidden]) a[href]');
        if (link && this.contains(link)) publishQuizEvent('quiz_product_view', {product: link.closest('[data-result]').dataset.result});
      }, { signal: this.controller.signal });
      this.addEventListener('submit', event => {
        const result = event.target.closest('[data-result]:not([hidden])');
        if (result) publishQuizEvent('quiz_add_to_cart_attempt', {product: result.dataset.result});
      }, { signal: this.controller.signal, capture: true });
    }
    disconnectedCallback() {
      clearTimeout(this.advanceTimer);
      cancelAnimationFrame(this.scrollFrame);
      this.videoObserver?.disconnect();
      this.querySelectorAll('.pq__video').forEach(video => video.pause());
      this.controller?.abort();
      this.controller = null;
    }
    show(screen, focus = true) {
      clearTimeout(this.advanceTimer);
      cancelAnimationFrame(this.scrollFrame);
      this.busy = false;
      this.screen = screen;
      this.dataset.currentScreen = screen;
      this.syncVideo();
      this.querySelectorAll('[data-screen]').forEach(node => { node.hidden = node.dataset.screen !== screen; });
      this.renderSelections();
      if (focus) {
        this.querySelector(`[data-screen="${screen}"] [data-focus]`)?.focus({ preventScroll: true });
        this.scrollFrame = requestAnimationFrame(() => {
          const target = this.querySelector(`[data-screen="${screen}"]:not([hidden])`);
          if (!target || this.screen !== screen || !this.isConnected) return;
          const headerBottom = Math.max(0, ...Array.from(document.querySelectorAll('[data-flow-header-shell], .announcement-bar'), node => {
            const rect = node.getBoundingClientRect();
            const style = getComputedStyle(node);
            return rect.width && rect.height && style.visibility !== 'hidden' && style.display !== 'none' ? Math.max(0, rect.bottom) : 0;
          }));
          const inset = parseFloat(getComputedStyle(this.closest('#main-content') || this).getPropertyValue('--ff-quiz-inset')) || 16;
          const transform = getComputedStyle(target).transform;
          const animatedOffset = transform === 'none' ? 0 : new DOMMatrixReadOnly(transform).m42;
          window.scrollTo({ top: Math.max(0, window.scrollY + target.getBoundingClientRect().top - animatedOffset - headerBottom - inset), behavior: 'instant' });
        });
      }
    }
    syncVideo() {
      this.querySelectorAll('.pq__video').forEach(video => {
        if (this.screen === 'intro' && this.videoVisible && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          video.muted = true;
          video.play().catch(() => {});
        } else video.pause();
      });
    }
    renderSelections() {
      this.querySelectorAll('[data-answer]').forEach(button => {
        const selected = this.answers[Number(button.dataset.question) - 1];
        const pressed = selected.includes(Number(button.dataset.answer));
        button.disabled = !this.availableKeys.length;
        button.setAttribute('aria-pressed', String(pressed));
        button.setAttribute('aria-disabled', String(!pressed && selected.length === 2));
      });
      this.querySelectorAll('[data-continue]').forEach(button => {
        button.disabled = !this.availableKeys.length || !this.answers[Number(button.dataset.continue) - 1].length;
      });
    }
    choose(button) {
      if (!this.availableKeys.length) return;
      const index = Number(button.dataset.question) - 1;
      if (this.screen !== `q${index + 1}`) return;
      const value = Number(button.dataset.answer);
      if (!POINTS[index]?.[value - 1]) return;
      const selected = this.answers[index];
      if (selected.includes(value)) this.answers[index] = selected.filter(answer => answer !== value);
      else if (selected.length < 2) selected.push(value);
      this.renderSelections();
    }
    continue() {
      const index = Number(this.screen.slice(1)) - 1;
      if (!this.availableKeys.length || !this.answers[index]?.length) return;
      if (index < 2) this.show(`q${index + 2}`);
      else this.result();
    }
    scores() {
      return scoreAnswers(this.answers);
    }
    winner() {
      return rankProducts(this.scores(), this.availableKeys)[0];
    }
    result() {
      if (!this.availableKeys.length || this.answers.some(answer => !answer.length)) return;
      const winner = this.winner();
      this.querySelectorAll('[data-result]').forEach(node => { node.hidden = node.dataset.result !== winner; });
      this.show('result');
      publishQuizEvent('quiz_complete', {product: winner, answers: this.answers.map(answer => [...answer])});
    }
    back() {
      const question = Number(this.screen.slice(1));
      if (!Number.isFinite(question)) return;
      this.show(question > 1 ? `q${question - 1}` : (this.dataset.intro === 'true' ? 'intro' : 'q1'));
    }
    reset() {
      this.answers = [[], [], []];
      this.querySelectorAll('[data-result]').forEach(node => { node.hidden = true; });
      this.show(this.dataset.intro === 'true' ? 'intro' : 'q1');
    }
  }
  customElements.define('product-quiz', ProductQuiz);
})();

  } catch(e) { console.error(e); }
})();
})();
